/** In-app install / pricing landing (Adobe Exchange CTA lives on this page) */
export const INSTALL_PAGE_PATH = '/pricing';

/** Only these paths are allowed for Stripe `cancel_url` (open-redirect safe). */
export const ALLOWED_STRIPE_CANCEL_PATHS = [
  INSTALL_PAGE_PATH,
  '/',
] as const;

/**
 * Picks a safe in-app path for Stripe checkout cancel redirects.
 * Unknown or missing values default to the install / pricing page.
 */
export function resolveStripeCancelPath(
  path: string | null | undefined
): string {
  if (path == null) {
    return INSTALL_PAGE_PATH;
  }
  const raw = String(path).trim();
  if (raw === '') {
    return INSTALL_PAGE_PATH;
  }
  let decoded: string;
  try {
    decoded = decodeURIComponent(raw);
  } catch {
    return INSTALL_PAGE_PATH;
  }
  if (!decoded.startsWith('/')) {
    return INSTALL_PAGE_PATH;
  }
  if (decoded.includes('//') || decoded.includes('..')) {
    return INSTALL_PAGE_PATH;
  }
  if (
    !(ALLOWED_STRIPE_CANCEL_PATHS as readonly string[]).includes(decoded)
  ) {
    return INSTALL_PAGE_PATH;
  }
  return decoded;
}

/** Substyle on Adobe Exchange */
export const ADOBE_EXCHANGE_URL =
  'https://exchange.adobe.com/apps/cc/204399/substyle';

// URLs for Stripe checkout
export const STRIPE_URLS = {
  // Stripe replaces {CHECKOUT_SESSION_ID} in the redirect URL.
  SUCCESS_URL: `${
    process.env.REACT_APP_ORIGIN || window.location.origin
  }/success?session_id={CHECKOUT_SESSION_ID}`,
  CANCEL_URL: `${
    process.env.REACT_APP_ORIGIN || window.location.origin
  }/pricing`, // Cancel page URL from env
};
